import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    customersList: [],
    documentTypes: [],
    importTags: [],
    lastStatusList: [],
    principlesList: [],
    customerUsersDeliveryOptions: [],
    generalDeliveryOptions: [],
    customerCoversheets: [],
    userDeliveryOptions: [],
    emailForm: {},
    customerUserExists: false,
    customerMultiReference: null
};

const getters = {
    getCustomersList: (state) => state.customersList,
    getDocumentTypes: (state) => state.documentTypes,
    getImportTags: (state) => state.importTags,
    getLastStatusList: (state) => state.lastStatusList,
    getPrinciplesList: (state) => state.principlesList,
    getCustomerUserDeliveryOptions: (state) => state.customerUsersDeliveryOptions,
    getGeneralDeliveryOptions: (state) => state.generalDeliveryOptions,
    getCustomerCoversheets: (state) => state.customerCoversheets,
    getUserDeliveryOptions: (state) => state.userDeliveryOptions,
    getEmailForm: (state) => state.emailForm,
    getCustomerUserExists: (state) => state.customerUserExists,
    getCustomerMultiReference: (state) => state.customerMultiReference
};

const actions = {
    //#EIPP-550 passing the data directly to the payload in the store. IS
    async getManageCustomersList( context, data ) {
        await axios.get(`${backendUrl()}/getManageCustomersList`,
        {
            params: {
                ...data.customersRequest ,
                page: data.page,
                per_page: data.per_page,
                // customerReference: data.customersRequest.customerReference,
                // customerMultiReference: data.customersRequest.customerMultiReference,
                // customerName: data.customersRequest.customerName,
                // emailSet: data.customersRequest.emailSet,
                // faxSet: data.customersRequest.faxSet,
                // telephoneSet: data.customersRequest.telephoneSet,
                // notesContain: data.customersRequest.notesContain,
                // importTag: data.customersRequest.importTag,
                // documentTypes: data.customersRequest.documentTypes,
                // lastStatus: data.customersRequest.lastStatus,
                // callOverdue: data.customersRequest.callOverdue,
                // docsInLastMonths: data.customersRequest.docsInLastMonths,
                // docsInLastMonthsAmount: data.customersRequest.docsInLastMonthsAmount,
                // emailFailure: data.customersRequest.emailFailure,
                // faxFailure: data.customersRequest.faxFailure,
                // submissionFailure: data.customersRequest.submissionFailure,
                // primaryContact: data.customersRequest.primaryContact,
                // principle: data.customersRequest.principle
            },
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setCustomersList', response.data.customersList)
            context.commit('setDocumentTypes', response.data.documentTypes)
            context.commit('setImportTags', response.data.importTags)
            context.commit('setLastStatusList', response.data.lastStatusList)
            context.commit('setPrinciplesList', response.data.principlesList)
            context.commit('setCustomerMultiReference', response.data.customerMultiReference)
        })
    },

    // get doc types, status and principle filters, NS-9773 PW
    async getCustomerFilters( context, data ) {
        await axios.post(`${backendUrl()}/getCustomerFilters`, null,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setDocumentTypes', response.data.documentTypes)
            context.commit('setLastStatusList', response.data.lastStatusList)
            context.commit('setPrinciplesList', response.data.principlesList)
            context.commit('setCustomerMultiReference', response.data.customerMultiReference)
        })
    },

    async getCustomerInformation( context, data ) {
        return await axios.get(`${backendUrl()}/getCustomerInformation/` + data, 
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },
    async updateCustomerInformation( context, data ) {
        await axios.post(`${backendUrl()}/updateCustomerInformation`, data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async updateCustomerUserDeliveryOptions( context, data ) {
        await axios.post(`${backendUrl()}/updateCustomerUserDeliveryOptions`,
        {
            customerId: data.customerId,
            users: data.users
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async updateGeneralDeliveryOptions( context, data ) {
        await axios.post(`${backendUrl()}/updateGeneralDeliveryOptions`,
        {
            customerId: data.customerId,
            deliveryRules: data.deliveryRules
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async updateCustomerCoversheets( context, data ) {
        await axios.post(`${backendUrl()}/updateCustomerCoversheets`,
        {
            updatedCustomerCoversheets: data.updatedCustomerCoversheets,
            customerId: data.customerId,
            userLevel: data.userLevel
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },    
    async addCustomerUserDeliveryOptions( context, data ) {
        await axios.post(`${backendUrl()}/addCustomerUserDeliveryOptions`,
        {
            realName: data.realName,
            email: data.email,
            password: data.password,
            headUser: data.headUser,
            customerId: data.customerId,
            currentUserId: data.currentUserId,
            protectedUser: data.protectedUser,
            existingUser: data.existingUser //NS-9873 SP
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            //NS-9873 SP If user exists for different customer return a flag
            if(response.data.customerUserExists) {
                context.commit('setCustomerUserExists', response.data.customerUserExists)
            } else {
                context.commit('setCustomerUserExists', false)
                context.dispatch('handleResponse', response, {root: true})
                if(response.data.status == 'error' &&  response.data.key == 'customerUserInvalidError'){
                    context.commit('setValidationErrors',response.data.errors, {root: true})
                } else {
                    context.commit('alertClearErrors', null, {root: true})
                }
            }
        })
    },
    async deleteCustomerUser( context, data ) {
        await axios.post(`${backendUrl()}/deleteCustomerUser`,
        {
            userId: data.userId,
            currentUserId: data.currentUserId,
            customerId: data.customerId
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async getGeneralDeliveryOptions( context, data){
        await axios.get(`${backendUrl()}/getGeneralDeliveryOptions/` + data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setGeneralDeliveryOptions', response.data)
            
        })
    },
    async getCustomerUsersDeliveryOptions( context, data){
        return await axios.get(`${backendUrl()}/getCustomerUsersDeliveryOptions/` + data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setCustomerUserDeliveryOptions', response.data)
        })
    },
    async getCustomerCoversheets( context, data){
        await axios.get(`${backendUrl()}/getCustomerCoversheets/` + data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setCustomerCoversheets', response.data)
        })
    },
    async getUserDeliveryOptionsList( context, data){
        await axios.get(`${backendUrl()}/getUserDeliveryOptionsList`,{
            params: {
                userId: data.userId,
                customerId: data.customerId
            },
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            if(response.data.status) {
                context.dispatch('handleResponse', response, {root: true})
            } else {
                context.commit('setUserDeliveryOptions', response.data)
            }
        })
    },
    async updateUserDeliveryOptions( context, data ) {
        await axios.post(`${backendUrl()}/updateUserDeliveryOptions`,
        {
            userDeliveryOptions: data.userDeliveryOptions,
            customerId: data.customerId,
            userId: data.userId
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async sendEmailToCustomerUser( context, data ) {
        await axios.post(`${backendUrl()}/sendEmailToCustomerUser`,
        {
            sendTo: data.sendTo,
            from: data.from,
            subject: data.subject,
            message: data.message,
            customerId: data.customerId
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
            if(response.data.status == 'error' &&  response.data.key == 'InvalidEmailError'){
                context.commit('setValidationErrors',response.data.errors, {root: true})
            } else {
                context.commit('alertClearErrors', null, {root: true})
            }
        })
    },
    async getCustomerUsersDetails( context, data){
        await axios.get(`${backendUrl()}/getCustomerUsersDetails`,{
            params: {
                customerId: data.customerId
            },
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            if(response.data.status) {
                context.dispatch('handleResponse', response, {root: true})
            } else {
                context.commit('setCustomerEmailForm', response.data)
            }
        })
    },
    async addCustomerUser( context, data ) {
        await axios.post(`${backendUrl()}/addCustomerUser`,
        {
            newUser: data.newUser,
            custId: data.custId
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },  
    async deleteSelectedCustomers( context, data ) {
        await axios.post(`${backendUrl()}/deleteSelectedCustomers`,
        {
            customerIds: data.customerIds,

        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })  
    },
    async updateNumberOfEmailAttachments( context, data ) {
        await axios.post(`${backendUrl()}/updateNumberOfEmailAttachments`,
        {
            customerId: data.customerId,
            number: data.number,
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    }    
};

const mutations = {
    setCustomersList: (state, customersList) => (state.customersList = customersList),
    setDocumentTypes: (state, documents) => (state.documentTypes = documents),
    setImportTags: (state, tags) => (state.importTags = tags),
    setLastStatusList: (state, statuses) => (state.lastStatusList = statuses),
    setPrinciplesList: (state, principles) => (state.principlesList = principles),
    setCustomerUserDeliveryOptions: (state, customerUsersDeliveryOptions) => (state.customerUsersDeliveryOptions = customerUsersDeliveryOptions),
    setGeneralDeliveryOptions: (state, generalDeliveryOptions) => (state.generalDeliveryOptions = generalDeliveryOptions),
    setCustomerCoversheets: (state, customerCoversheets) => (state.customerCoversheets = customerCoversheets),
    setUserDeliveryOptions: (state, userDeliveryOptions) => (state.userDeliveryOptions = userDeliveryOptions),
    setCustomerEmailForm: (state, emailForm) => (state.emailForm = emailForm),
    setCustomerUserExists: (state, customerUserExists) => (state.customerUserExists = customerUserExists),
    setCustomerMultiReference: (state, customerMultiReference) => (state.customerMultiReference = customerMultiReference)

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
